import createIcon from '../../createIcon';

/**
 * @component @name ReplayCircleFilled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDJDNi40OCAyIDIgNi40OCAyIDEyQzIgMTcuNTIgNi40OCAyMiAxMiAyMkMxNy41MiAyMiAyMiAxNy41MiAyMiAxMkMyMiA2LjQ4IDE3LjUyIDIgMTIgMlpNMTggMTJDMTggMTUuMzEgMTUuMzEgMTggMTIgMThDOC42OSAxOCA2IDE1LjMxIDYgMTJIOEM4IDE0LjIxIDkuNzkgMTYgMTIgMTZDMTQuMjEgMTYgMTYgMTQuMjEgMTYgMTJDMTYgOS43OSAxNC4yMSA4IDEyIDhWMTFMOCA3TDEyIDNWNkMxNS4zMSA2IDE4IDguNjkgMTggMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ReplayCircleFilled = createIcon('ReplayCircleFilled', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM18 12C18 15.31 15.31 18 12 18C8.69 18 6 15.31 6 12H8C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8V11L8 7L12 3V6C15.31 6 18 8.69 18 12Z',
      key: '1vvuks',
    },
  ],
]);

export default ReplayCircleFilled;
